export default "__VITE_ASSET__BTu1OnKp__"